import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export interface ProgramDetails {
  id: number;
  program: string;
  year: number;
  company: string;
  supervisorName: string;
  supervisorPhone: string;
  duration: string;
}

interface ProgramDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  data: ProgramDetails[];
}

const ProgramDetailsDialog: React.FC<ProgramDetailsDialogProps> = ({
  open,
  onClose,
  data,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Enrolled Programs</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table size="small" aria-label="program details table">
            <TableHead>
              <TableRow>
                <TableCell>Program</TableCell>
                <TableCell>Year</TableCell>
                <TableCell>Company</TableCell>
                <TableCell>Supervisor Name</TableCell>
                <TableCell>Supervisor Phone</TableCell>
                <TableCell>Duration</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item) => (
                <TableRow key={`row-${item.id}`}>
                  <TableCell>{item.program}</TableCell>
                  <TableCell>{item.year}</TableCell>
                  <TableCell>{item.company}</TableCell>
                  <TableCell>{item.supervisorName}</TableCell>
                  <TableCell>{item.supervisorPhone}</TableCell>
                  <TableCell>{item.duration}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default ProgramDetailsDialog;
